import type { MessagingChannelsCopy } from './types';

export const ZH_TW: MessagingChannelsCopy = {
  title: '訊息管道',
  description:
    '在你常用的聊天應用程式裡和 IMAI 對話。連線一次，之後就能在那裡傳訊息給 IMAI。',
  privacy:
    '來自你已連線帳號的訊息會以你的身分在此工作區中執行，並使用你的點數。',
  loading: '正在載入訊息管道',
  unavailable: '尚未開放',
  unavailableNote: '{channel} 尚未為 IMAI 設定。',
  connectedBadge: '已連線',
  cancel: '取消',

  addNumber: '新增號碼',
  countryLabel: '國家/地區代碼',
  countrySearch: '搜尋國家或區碼…',
  countryEmpty: '找不到國家。',
  numberLabel: '手機號碼',
  continueActivation: '繼續',
  editNumber: '更換號碼',
  activateQr: '掃描後點按傳送',
  activateHint: '開啟{channel}後點按傳送。',
  activationBack: '返回',
  activateButton: '開啟{channel}',
  activateWaiting: '正在等待你的訊息，{time} 後過期。',
  startAgain: '重新開始',
  remove: '移除',
  removeAria: '移除手機號碼 {number}',
  removeTitle: '要移除 {number} 嗎？',
  removeDescription:
    'IMAI 將不再於 iMessage 和 WhatsApp 回覆這個號碼。你可以隨時重新新增。',
  removeError: '無法移除號碼，請再試一次。',

  errorInvalidNumber: '請輸入有效的手機號碼（包含區碼）。',
  errorNumberTaken: '這個號碼已被另一個 IMAI 帳號使用。',
  errorRateLimited: '嘗試次數過多，請稍後再試。',
  errorChannelUnavailable: '此方式暫時無法使用，請選擇另一種。',
  errorSendFailed: '無法開始驗證，請再試一次。',
  errorActivationExpired: '這次啟用已過期，請重新開始。',

  noteSlack: '在你的 Slack 工作區傳訊息給 IMAI。',
  noteTeams: '在 Microsoft Teams 上傳訊息給 IMAI。',
  noteTelegram: '在 Telegram 上和 IMAI 機器人聊天。',
  connect: '連線',
  connectAria: '連線 {channel}',
  connectError: '無法開始連線 {channel}，請再試一次。',
  connectedOn: '連線於 {date}',
  accountFallback: '你的 {channel} 帳號',
  installSlack: '將 IMAI 加入你的工作區',
  installTeams: '將 IMAI 加入 Teams',
  openTelegram: '在 Telegram 中開啟',
  disconnect: '中斷連線',
  disconnectAria: '中斷 {account} 與 {channel} 的連線',
  disconnectError: '無法中斷 {channel} 的連線，請再試一次。',
  disconnectTitle: '要中斷 {channel} 的連線嗎？',
  disconnectDescription:
    '來自 {account} 的訊息將不再傳給 IMAI。你可以隨時重新連線。',

  toastConnected: '已連線 {channel}',
  toastConnectedGeneric: '帳號已連線',
  toastErrorExpired: '登入時間過長，請重新連線。',
  toastErrorInvalidState: '這個登入連結已失效，請再試一次。',
  toastErrorAccountTaken: '這個帳號已連線到另一位 IMAI 使用者。',
  toastErrorNotMember: '你已不是此工作區的成員。',
  toastErrorProvider: '登入未完成，請重新連線。',
  toastErrorGeneric: '無法連線帳號，請再試一次。',
};
